import { createTheme } from "@material-ui/core/styles"

export const theme = createTheme({
  palette: {
    primary: {
      main: "#ffffff",
    },
    secondary: {
      main: "#ffcf10",
    },
  },
})
